import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import SelectFromLibr from "../../Add_From_Library/Select_from_Library/SelectFromLibr";
import QuestionListHomework from "../Preview_Question_List/QuestionListHomework";
import "../../Create_Assessment/Create_Question/CreateQuestionHw.css";
import DefaultQuestion from "./Create_Q_Type/DefaultQuestion";
import axios from "../../../../axios";
import { isDisabled } from "@testing-library/user-event/dist/utils";

const TeacherId = localStorage.getItem("Teacher_id");
const jsonTeacherId = JSON.parse(TeacherId);

const CreateQuestion = ({
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
}) => {
  const navigate = useNavigate();
  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;
  const [click, setClick] = useState(false);
  const [click1, setClick1] = useState(false);
  const [sourceLibrary, setSourceLibrary] = useState(null)
  const [isInProgress, setIsInProgress] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const [questionData, setquestionData] = useState([])

  const [skillsData, setSkillsData] = useState([])
  const [difficulty_levelData, setDifficulty_levelData] = useState([])
  const [questionType, setQuestionType] = useState([])
  const [countSkills, setCountSkills] = useState([])
  const [countDifficulty, setCountDifficulty] = useState([])
  const [countQsType, setCountQsType] = useState([])
  const [questions, setQuestions] = useState([
    {
      standard_id: standard_id ? standard_id?.id : null,
      subject_id: subject_id ? subject_id?.id : null,
      section_id: section_id ? section_id?.id : null,
      book_id: null,
      chapter_id: null,
      type_id: null,
      question_type: "null",
      domain_id: null,
      skill_id: null,
      difficulty_level: null,
      title: null,
      correct_score: null,
      is_mandatory: false,
      add_to: null,
      attachments: [],
      options: [
        {
          key: "A",
          value: null,
        },
        {
          key: "B",
          value: null,
        },
      ],
      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: {
            explanation: null,
          },
        },
      ],
    },
  ]);



  useEffect(() => {
    const hasFullObject = questions.some(obj => {
      return (
        obj?.title === null ||
        obj.skill_id === null ||
        obj.domain_id === null ||
        obj.type_id === null ||
        obj.chapter_id === null ||
        // obj.correct_score === null ||
        obj.difficulty_level === null ||
        (obj?.options?.length > 0 && obj.options.some(opt => opt?.value === null || opt?.value === ''))
      );
    });
    setIsFull(!hasFullObject);
  }, [questions]);

  const addMoreQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        standard_id: standard_id ? standard_id?.id : null,
        subject_id: subject_id ? subject_id?.id : null,
        section_id: section_id ? section_id?.id : null,
        book_id: null,
        chapter_id: null,
        question_type: "null",
        type_id: null,
        domain_id: null,
        skill_id: null,
        difficulty_level: null,
        title: null,
        correct_score: null,
        is_mandatory: false,
        add_to: null,
        attachments: [],
        options: [
          {
            key: "A",
            value: null,
          },
          {
            key: "B",
            value: null,
          },
        ],
        correct_answers: [
          {
            option_key: null,
            value: null,
            reason_for_answer: {
              attachment: null,
              explanation: null,
            },
          },
        ],
      },
    ]);
  };
  useEffect(() => {
    questions.forEach((obj) => {
      if (
        obj?.title === null ||
        obj.skill_id === null ||
        obj.domain_id === null ||
        obj.type_id === null ||
        obj.chapter_id === null ||
        obj.correct_score === null ||
        obj.difficulty_level === null
      ) {
        setBtnDisable(true);
        console.log(btnDisable, "isDis")
      } else {
        setBtnDisable(false);
      }
    });
  });
  // console.log("questions", questions);
  const checkAllDataField = () => {
    // Iterate over each question in the questions array
    for (let question of questions) {
      // Check for missing required fields for each question
      if (
        !question.title ||
        !question.skill_id ||
        !question.domain_id ||
        !question.type_id ||
        !question.chapter_id ||
        !question.difficulty_level
      ) {
        return true; // Disable if any required field is missing in any question
      }

      // Check for missing options values for each question
      if (
        question?.options?.length > 0 &&
        question.options.some(
          (opt) => opt?.value === null || opt?.value.trim() === ""
        )
      ) {
        return true; // Disable if any option value is missing in any question
      }

      // Check for missing correct answer keys for each question
      if (
        question?.options?.length > 0 &&
        question?.correct_answers.length > 0 &&
        question.correct_answers.some(
          (opt) =>
            !opt?.option_key || opt?.option_key.trim() === ""
        )
      ) {
        return true; // Disable if any correct answer key is missing in any question
      }
    }

    return false; // Enable if all checks are passed for all questions
  };


  const handleCreateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      total_duration: assessmentDetails.total_duration || null,
      questions: questions.map((question) => {
        if (question.correct_score === null || question.correct_score === undefined) {
          return { ...question, correct_score: 0 };
        }
        return question;
      }),
    };

    try {
      let res = await axios.post(`/api/v1/homework/create`, newAssessment);
      res && navigate("/PublishedHomework");
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const findTotalMarks = () => {
    return questions.reduce((acc, curr) => acc + Number(curr.correct_score), 0);
  };

  useEffect(() => {
    const dataCounter = {
      Skills: {},
      DifficultyLevel: {},
      QuestionType: {}
    }
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.question_type !== null) {
        if (dataCounter['QuestionType'][item.question_type] === undefined) {
          dataCounter['QuestionType'][item.question_type] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['QuestionType'][item.question_type] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['Skills'][item.skill_id] === undefined) {
          dataCounter['Skills'][item.skill_id] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['Skills'][item.skill_id] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['DifficultyLevel'][item.difficulty_level] === undefined) {
          dataCounter['DifficultyLevel'][item.difficulty_level] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['DifficultyLevel'][item.difficulty_level] += correctScore
        }
      }
      setCountDifficulty({})
    })

    setCountQsType(dataCounter)
    setCountSkills(dataCounter)
    setCountDifficulty(dataCounter)
    // question_type,skill_id,difficulty_level
  }, [questions])


  console.log(btnDisable && isFull)

  const getquestiondata = (data) => {
    setquestionData(data)

  }
  // console.log("qestiondata", qestiondata)
  return (
    <>
      <div className="d-flex align-items-center" style={{ position: "relative" }}>
        <div onClick={() => setClickFromCreate((prev) => !prev)}>
          <img src="/images/Back Arrow.svg" alt=""></img>
          <span className="published_hw_file_path1">
            &nbsp; Homework /&nbsp;
          </span>
        </div>
        <span className="published_hw_file_path2">Create homework</span>
        <div className="needfulinfo d-flex gap-3 align-item-center p-2" style={{ position: "absolute", top: "-40px", left: "280px" }}>
          <div className="allmarks d-">
            <div className="sktext d-flex justify-content-between flex-column"><span>Total Marks: {findTotalMarks()}</span> <span>Total Question: {questions.length}</span></div>
          </div>
          <div className="skills d-flex align-item-center justify-content-center border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <div className="needfulimg">
              <img src="/images/needfulimg.png" alt="needfulimg" style={{ width: "265px", marginRight: "12px" }}></img>
            </div>
            <div className="textpart">
              <h5 className="needful_heading">Skills</h5>
              {
                skillsData?.map((curr, index) => {
                  return (
                    <div className="sktext d-flex justify-content-between"> <span>{curr.name + " : "}</span> <span className="ms-4">{countSkills.Skills[curr.id] === undefined ? 0 : countSkills.Skills[curr.id]}</span></div>
                  )
                })
              }
            </div>
          </div>
          <div className="difficulty_level border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <h5 className="needful_heading">Difficulty Level</h5>
            {
              difficulty_levelData?.map((curr, index) => {
                return (
                  <div className="diftext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span>{countDifficulty.DifficultyLevel[curr.id] === undefined ? 0 : countDifficulty.DifficultyLevel[curr.id]}</span></div>
                )
              })
            }
          </div>
          <div className="ques_type border border-2 rounded-3" style={{ padding: "6px 15px" }}>
            <h5 className="needful_heading">Question Type</h5>
            {
              questionType?.map((curr, index) => {
                return (
                  <div className="qstext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span className="ms-3">0</span></div>
                )
              })
            }
          </div>
        </div>
      </div>
      <div className="NameSubAddToLib">
        <div>
          <div className="mt-2 ms-1 published_tittle_heading">
            {description}
          </div>
          <div className=" col-12 gap-2 p-0 flex-wrap mt-2 d-flex justify-content-between align-items-center">
            <div className="ms-1 col-md-2 p-0 hw_header_subject_name">
              {subject_id?.name}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end flex-column">
          <div
            className=" gap-2 mb-2 d-flex align-items-start justify-content-start  hw_library_btn1"
            onClick={() => {setClick1(true);setSourceLibrary("FROM_SCHOOL_LIBRARY")}}
          >
            <img src="/images/add button.svg" alt="" />
            <span>Add From School Library</span>
          </div>
          <div
            className=" gap-2 d-flex align-items-start justify-content-start  hw_library_btn1"
            onClick={() => {setClick1(true);setSourceLibrary("FROM_B4S_LIBRARY")}}
          >
            <img src="/images/add button.svg" alt="" />
            <span>Add from B4S Library</span>
          </div>
        </div>
      </div>
      <div className="hw_question_container">
        {questions.length > 0 &&
          questions.map((question, index) => (
            <DefaultQuestion
              key={index}
              nextQuestion={index}
              question={question}
              qArr={questions}
              setQuestions={setQuestions}
              assessmentDetails={assessmentDetails}
              setSkillsData={setSkillsData}
              setDifficulty_levelData={setDifficulty_levelData}
              setQuestionType={setQuestionType}
            />
          ))}

        {!checkAllDataField() && (
          <div className="mt-2 d-flex align-items-center justify-content-center">
            <button
              id="Add-options-btn"
              className="btn  add_question_button"
              type="button"
              onClick={addMoreQuestion}
            >
              <img src="/images/add button.svg" className="mx-1" alt=""></img>
              Add question
            </button>
          </div>
        )}

        <div className="mt-2 me-2 d-grid gap-2 d-md-flex justify-content-md-end mt-5 ">
          <button
            onClick={handleCreateAssessment}
            disabled={checkAllDataField()}
            className="btn draft_button"
          >
            Save as Draft
          </button>

          <button
            disabled={checkAllDataField()}
            className="btn  next_button"
            onClick={(e) => setClick(true)}
          >
            Next
          </button>
        </div>
      </div>

      {click && (
        <QuestionListHomework
          name={name}
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          sourceLibrary={sourceLibrary}
        />
      )}

      {click1 && (
        <SelectFromLibr
          setClick1={setClick1}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
          getquestiondata={getquestiondata}
        />
      )}

      {isInProgress && (
        <div className="loader_bg">
          <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}
    </>
  );
};

export default CreateQuestion;
